'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const VolumeItemText = styled(Box)(() => ({
//
}));

export default VolumeItemText;
